(function () {
    //This turns the title attribute into bootstrap tooltips, we have to run it periodically
    //because as html is added to the page we have to run this again.
    window.setInterval(function () {
        if ($("body").tooltip) {
            $("body").tooltip({ selector: '[title]' });
        }
    }, 500);
})();